// Busca nas listas.
//
// Com 16 camadas já são duas telas; a PoC tinha 127 serviços. Rolar até achar
// deixa de funcionar muito antes disso — e a tela de Camadas é onde se passa o
// dia.
//
// Filtra no cliente de propósito: as listas de catálogo são pequenas (dezenas,
// não milhares) e já estão na memória. Uma busca no servidor aqui acrescentaria
// latência a cada tecla para resolver um problema que não existe nessa escala.

import type { ReactNode } from "react";

export function Busca({
  valor,
  aoMudar,
  rotulo,
  achados,
  total,
}: {
  valor: string;
  aoMudar: (v: string) => void;
  rotulo: string;
  achados: number;
  total: number;
}): ReactNode {
  return (
    <div className="busca">
      <input
        type="search"
        aria-label={rotulo}
        placeholder={rotulo}
        value={valor}
        onChange={(e) => aoMudar(e.target.value)}
      />
      {/* O contador some quando não há filtro: "16 de 16" é ruído. */}
      {valor.trim() !== "" ? (
        <span className="discreto">
          {achados} de {total}
        </span>
      ) : null}
    </div>
  );
}

/** Normaliza para comparar: acento e caixa não deviam atrapalhar quem busca. */
export function casa(texto: string, busca: string): boolean {
  const limpa = (t: string): string => t.normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase();
  return limpa(texto).includes(limpa(busca.trim()));
}
